module.exports = __webpack_public_path__ + "img/logo.dcaa2507.svg";